module.exports = __webpack_public_path__ + "img/milestone-logo.02fc2439.png";